/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AssignExperimentGroupsContainer_user$ref: FragmentReference;
export type AssignExperimentGroupsContainer_user = {|
  +id: string,
  +joined: ?string,
  +$refType: AssignExperimentGroupsContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AssignExperimentGroupsContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "joined",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f4aa90f54f79b136be7e4764da1f0611';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/AssignExperimentGroupsContainer_user.graphql.js